const getRangeItemIdsByIndexes = (items, startIndex, endIndex) =>
  items.slice(startIndex, endIndex).map((item) => item.id);

export default getRangeItemIdsByIndexes;
